import { useParams } from 'react-router-dom';

import { useGetChunkV2 } from '@/api/queries/useGetChunkV2';
import { ChunkDocViewer } from '@/new/components/doc-viewer/chunk-doc-viewer';
import { ChunkDrawerContentShell } from '@/new/components/reference-content/chunk-drawer-content-shell';

interface ChunkDocumentDrawerContentProps {
  chunkId: string;
}

export function ChunkDocumentDrawerContent({ chunkId }: ChunkDocumentDrawerContentProps) {
  const { matterId } = useParams();
  const { data: chunk, isLoading, error } = useGetChunkV2(matterId, chunkId);

  return (
    <ChunkDrawerContentShell
      isLoading={isLoading}
      error={error}
      errorLabel="chunk"
      viewer={
        chunk ? (
          <ChunkDocViewer docId={chunk.docId} chunkId={chunk.id} boundingBoxes={chunk.boundingBoxes} />
        ) : null
      }
      tab={{ id: chunk?.docId ?? '', label: chunk?.doc.file.name ?? '' }}
      sourceText={chunk?.content ?? ''}
    />
  );
}
